import leadListStore from '@/store/lead/lead-list-store'

export default {
  namespaced: true,
  modules: {
    list: leadListStore
  }
}
